import formatBBAN from "./formatBBAN";

export default function formatIBAN(iban: string): string {
  if (!iban) return iban;
  return `${iban.slice(0,4)} ${formatBBAN(iban.slice(4), iban.slice(0,2))}`;
}
